import Fbservice from 'FB';
import AppService from 'app.service';
import config from 'config';
import { getIsPurchase, getLoginCount, increaseLoginCount, getTokenCode } from 'utils/auth';

const loadPaymentSdk = () => {
  return new Promise(resolve => {
    ((d, s, id) => {
      let js,
        fjs = d.getElementsByTagName(s)[0];
      if (d.getElementById(id)) {
        resolve(1);
      }
      js = d.createElement(s);
      js.id = id;
      js.src = config.payment.sdk;
      fjs.parentNode.insertBefore(js, fjs);
      js.onload = () => resolve({ sts: 's' });
    })(document, 'script', 'payment-jssdk');
  });
};

const readLocationHashParams = hashParams => {
  const result_map = {};
  if (hashParams) {
    const param_arr = hashParams.split('#')[1].split('&');
    param_arr.forEach(item => {
      const key = item.split('=')[0];
      const value = item.split('=')[1];
      result_map[key] = value;
    });
  }
  return result_map;
};

const run = async ({ hashParams }) => {
  let fbUser;
  const fbHashParamsMap = readLocationHashParams(hashParams);
  const state = { user: null, store: null, dailyBonusTime: null, isNewSession: false };

  await Fbservice.initSdk();
  await loadPaymentSdk();

  if (fbHashParamsMap.access_token) {
    const loginCount = getLoginCount();
    const isPurchase = getIsPurchase();
    isPurchase && loginCount <= 3 && increaseLoginCount();
    state.isNewSession = true;
    fbUser = await Fbservice.handleUserResponse({
      status: 'connected',
      authResponse: fbHashParamsMap,
    });
  } else {
    fbUser = await Fbservice.checkStatus();
  }

  const tokenCode = getTokenCode() || undefined;
  if (!fbUser && !tokenCode) return state;
  const loginData = await AppService.storeUserLogin({ fbUser, ton: tokenCode });
  if (loginData) {
    const { plr, dBCn } = loginData;
    state.user = { ...fbUser, ...plr };
    if (dBCn) state.dailyBonusTime = dBCn;
  }

  return state;
};

export default run;
